var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroundLevel = function SvgGroundLevel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3019_8687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.74361 9.11489C3.01323 8.75811 2.99109 7.72523 3.7055 7.33747L10.7712 3.5025C11.3506 3.18798 12.0479 3.17926 12.635 3.4792L20.164 7.32526C20.9077 7.7052 20.8856 8.7755 20.1268 9.12437L12.5584 12.604C12.0132 12.8546 11.3843 12.8472 10.8451 12.5839L3.74361 9.11489Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69934 10.2554L3.7055 11.3376C2.99109 11.7253 3.01323 12.7582 3.74361 13.115L10.8451 16.584C11.3843 16.8473 12.0132 16.8547 12.5584 16.604L20.1268 13.1244C20.8856 12.7756 20.9077 11.7053 20.164 11.3253L18.0694 10.2554",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69934 14.2552L3.7055 15.3374C2.99109 15.7252 3.01323 16.758 3.74361 17.1148L10.8451 20.5838C11.3843 20.8472 12.0132 20.8546 12.5584 20.6039L20.1268 17.1243C20.8856 16.7754 20.9077 15.7051 20.164 15.3252L18.0694 14.2552",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3019_8687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export default SvgGroundLevel;